import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExercisesComponent} from './exercises/exercises.component'
import { TopicComponent } from './topic/topic.component';
import { TeacherGuard } from '../App/teacher-guard.service';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { TExamComponent } from './t-exam/t-exam.component';
import {TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';

import { EncodeTextComponent } from './encode-text/encode-text.component';
import { TEncodeTextComponent } from './t-encode-text/t-encode-text.component';

import { DecodeTextComponent } from './decode-text/decode-text.component';
import { TDecodeTextComponent } from './t-decode-text/t-decode-text.component';

import { DecodeWithoutKeyComponent } from './decode-without-key/decode-without-key.component';
import { TDecodeWithoutKeyComponent } from './t-decode-without-key/t-decode-without-key.component';

import { DefineKeyComponent } from './define-key/define-key.component';
import { TDefineKeyComponent } from './t-define-key/t-define-key.component';

import { DiscoverComponent } from './discover/discover.component';
import { TDiscoverComponent } from './t-discover/t-discover.component';
import { LearnByHeartComponent } from './learn-by-heart/learn-by-heart.component';
import { TLearnByHeartComponent } from './t-learn-by-heart/t-learn-by-heart.component';
import { PlaygroundComponent } from './playground/playground.component';

import { ExampleComponent } from './example/example.component';
import { TExampleComponent } from './t-example/t-example.component';


const dataRepresentationRoutes: Routes = [
  { path: 'crypto', component:TopicComponent,
    children : [
      { path: '', component: ExercisesComponent, pathMatch: 'full'},
      { path: 'exam/:id', component: ExamComponent},
      { path: 'exam/:id/evaluation', component: EvaluationComponent},
      { path: 'exam/:examid/openQuestion/:id', component: OpenQuestionComponent}, 
      { path: 'exam/:examid/multipleChoice/:id', component: MultipleChoiceComponent},
      { path: 'openQuestion/:id', component: OpenQuestionComponent}, 
      { path: 'multipleChoice/:id', component: MultipleChoiceComponent},
      { path: 'playground', component: PlaygroundComponent},
      
      { path: 'encodeText/:id', component: EncodeTextComponent},
      { path: 'exam/:examid/encodeText/:id', component: EncodeTextComponent},

      
      { path: 'decodeText/:id', component: DecodeTextComponent},
      { path: 'exam/:examid/decodeText/:id', component: DecodeTextComponent},

      
      { path: 'decodeWithoutKey/:id', component: DecodeWithoutKeyComponent},
      { path: 'exam/:examid/decodeWithoutKey/:id', component: DecodeWithoutKeyComponent},

      { path: 'defineKey/:id', component: DefineKeyComponent},
      { path: 'exam/:examid/defineKey/:id', component: DefineKeyComponent},

      
      { path: 'discover/:id', component: DiscoverComponent},
      { path: 'exam/:examid/discover/:id', component: DiscoverComponent},
      
      { path: 'learnByHeart/:id', component: LearnByHeartComponent},
      { path: 'exam/:examid/learnByHeart/:id', component: LearnByHeartComponent},

      { path: 'example/:id', component: ExampleComponent},
      { path: 'exam/:examid/example/:id', component: ExampleComponent}

    ] },
    {path: 'teacher/crypto', canActivate: [TeacherGuard], canActivateChild:[TeacherGuard], component: TopicComponent,
      children:[
      { path: '', component: TExercisesComponent, pathMatch: 'full'},
      { path: 'openQuestion', component: TOpenQuestionComponent}, 
      { path: 'multipleChoice', component: TMultipleChoiceComponent},
      { path: 'openQuestion/:id', component: TOpenQuestionComponent}, 
      { path: 'multipleChoice/:id', component: TMultipleChoiceComponent},
      { path: 'allExercisesTeacher', component: TAllExercisesComponent},
      { path: 'allExamsTeacher', component: TAllExamsComponent},

      { path: 'encodeText', component: TEncodeTextComponent},
      { path: 'encodeText/:id', component: TEncodeTextComponent},

      { path: 'decodeText', component: TDecodeTextComponent},
      { path: 'decodeText/:id', component: TDecodeTextComponent},

      { path: 'decodeWithoutKey', component: TDecodeWithoutKeyComponent},
      { path: 'decodeWithoutKey/:id', component: TDecodeWithoutKeyComponent},
      
      { path: 'defineKey', component: TDefineKeyComponent},
      { path: 'defineKey/:id', component: TDefineKeyComponent},

      
      { path: 'discover', component: TDiscoverComponent},
      { path: 'discover/:id', component: TDiscoverComponent},
      
      { path: 'learnByHeart', component: TLearnByHeartComponent},
      { path: 'learnByHeart/:id', component: TLearnByHeartComponent},
      
      { path: 'example', component: TExampleComponent},
      { path: 'example/:id', component: TExampleComponent},

      { path: 'exam', component: TExamComponent},
      { path: 'exam/:examid', component: TExamComponent, pathMatch: 'full'},
        { path: 'exam/:examid/allExercisesTeacher', component: TAllExercisesComponent},
        { path: 'exam/:examid/openQuestion', component: TOpenQuestionComponent},
        { path: 'exam/:examid/openQuestion/:id', component: TOpenQuestionComponent},
        { path: 'exam/:examid/multipleChoice', component: TMultipleChoiceComponent},
        { path: 'exam/:examid/multipleChoice/:id', component: TMultipleChoiceComponent},

      { path: 'exam/:examid/encodeText', component: TEncodeTextComponent},
      { path: 'exam/:examid/encodeText/:id', component: TEncodeTextComponent},

      { path: 'exam/:examid/decodeText', component: TDecodeTextComponent},
      { path: 'exam/:examid/decodeText/:id', component: TDecodeTextComponent},

      { path: 'exam/:examid/decodeWithoutKey', component: TDecodeWithoutKeyComponent},
      { path: 'exam/:examid/decodeWithoutKey/:id', component: TDecodeWithoutKeyComponent},

      
      { path: 'exam/:examid/defineKey', component: TDefineKeyComponent},
      { path: 'exam/:examid/defineKey/:id', component: TDefineKeyComponent},
      
      { path: 'exam/:examid/discover', component: TDiscoverComponent},
      { path: 'exam/:examid/discover/:id', component: TDiscoverComponent},
      
      { path: 'exam/:examid/learnByHeart', component: TLearnByHeartComponent},
      { path: 'exam/:examid/learnByHeart/:id', component: TLearnByHeartComponent},

      { path: 'exam/:examid/example', component: TExampleComponent},
      { path: 'exam/:examid/example/:id', component: TExampleComponent}
    ] }
];

@NgModule({
  imports: [
      RouterModule.forChild(dataRepresentationRoutes)
  ],
  declarations: [],
  exports: [
    RouterModule]
})
export class TopicRoutingModule { }
